import * as func from './functions';
import VenoBox from 'venobox';

new VenoBox({
    selector: "[data-lightbox]"
});